import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderAppointment = createAsyncThunk("provdier/get-appointment", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-appointment`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers appointments");
  }
});

export const getProviderAppointmentDetails = createAsyncThunk("provdier/get-appointment-detail", async ({token, id}, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-appointment-detail/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers appointments details");
  }
});

export const addProviderAppointmentNotes = createAsyncThunk(
  "provider/add-appointment-notes",
  async ({ token, appointment_id, data }, thunkAPI) => {
    try {
          const response = await axios.post(
            `${BACKEND_URL}/provider/add-appointment-notes/${appointment_id}`,
            data,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Add favourites failed"
      );
    }
  }
);

const providerAppointmentSlice = createSlice({
  name: "providerAppointment",
    initialState: {
      providerAppointments: null,
      providerAppointmentDetails: null,
      loading: false,
      error: null,
      message: "",
      
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderAppointment.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderAppointment.fulfilled, (state, action) => {
            state.providerAppointments = action.payload.providerAppointment;
            state.loading = false;
        })
        .addCase(getProviderAppointment.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers appointments"; 
            state.loading = false;
        })
        .addCase(getProviderAppointmentDetails.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderAppointmentDetails.fulfilled, (state, action) => {
            state.providerAppointmentDetails = action.payload.providerAppointment;
            state.loading = false;
        })
        .addCase(getProviderAppointmentDetails.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers appointments"; 
            state.loading = false;
        })
         },
});

export default providerAppointmentSlice.reducer;